const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const wholeUsd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

const count = new Intl.NumberFormat('en-US');

export function formatUsd(value: number): string {
  return usd.format(value);
}

export function formatWholeUsd(value: number): string {
  return wholeUsd.format(value);
}

export function formatSignedUsd(value: number): string {
  return value > 0 ? `+${usd.format(value)}` : usd.format(value);
}

export function formatBps(value: number, signed = false): string {
  return `${signed && value > 0 ? '+' : ''}${value} bps`;
}

export function formatPct(value: number): string {
  return `${value.toFixed(2)}%`;
}

export function formatCount(value: number): string {
  return count.format(value);
}

/** Sums money values in integer cents to avoid floating point drift. */
export function sumCents(values: number[]): number {
  return values.reduce((total, value) => total + Math.round(value * 100), 0) / 100;
}
